module.exports = __webpack_public_path__ + "img/DSC_1128.240d6a62.jpg";